import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateAgoPipe } from './date-ago.pipe';
import { DateFormatPipe } from './date-format';
import { DistanceConversionPipe } from './distance-converter.pipe';
import { SortPipe } from './sort.pipe';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    DateAgoPipe,
    SortPipe,
    DistanceConversionPipe,
    DateFormatPipe
  ],
  exports: [
    DateAgoPipe,
    SortPipe,
    DistanceConversionPipe,
    DateFormatPipe
  ],
  providers: [
    DateAgoPipe,
    SortPipe,
    DateFormatPipe,
    DistanceConversionPipe
  ]
})
export class PipesModule { }
